module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card_noborder': _vm.noborder
    }
  }, [(_vm.date) ? _c('Date', [_vm._v(_vm._s(_vm.date) + " года")]) : _c('Date', [_vm._v("Дата не определена")]), _vm._l((_vm.items), function(item, index) {
    return _c('Block', {
      key: index,
      attrs: {
        "id": _vm.id,
        "item": item,
        "date": _vm.date,
        "noFormatDate": _vm.noFormatDate,
        "showAddition": _vm.showAddition
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0136ef76","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/compopnents/card/Card.vue
// module id = 70eb82000bdd10afd9cb
// module chunks = 89